// extracted by mini-css-extract-plugin
export default {"wrapper":"ManaHeader_wrapper__IVS+J","user":"ManaHeader_user__CNMdj","resetPassword":"ManaHeader_resetPassword__D0Sk0"};